(function ($) {
  $.widget("easy.easytreeview", {
    options: {
      url: null,
      data_attribute: "id",
    },
    _create: function () {
      var that = this;
      this.options.url = this.options.url || this.element.data("url") || window.location.href;

      $(this.element).on("click", ".project-parent-expander", function (event) {
        that._onRootClick(this);
        event.stopPropagation();
      });
    },

    _onRootClick: function (el) {
      var $rootEl = $(el),
        tr = $rootEl.closest("tr");

      if ($rootEl.hasClass("open")) {
        var row = tr.next();
        while (parseInt(row.data("level")) > parseInt(tr.data("level"))) {
          row.hide();
          row = row.next();
        }
        $rootEl.removeClass("open");
        $rootEl.attr("aria-expanded", "false");
      } else {
        if ($rootEl.hasClass("preloaded")) {
          $rootEl.addClass("open");
          var row = tr.next();
          while (parseInt(row.data("level")) > parseInt(tr.data("level"))) {
            row.show();
            row = row.next();
          }
          var rows = tr.nextUntil("tr.root");
          var expanders = rows.find(".project-parent-expander:not(.open)");
          $.each(expanders, function (_, value) {
            var data = $(value).data();
            if (data) {
              $("tr." + data.prefix + "parentproject_" + data.id).hide();
            }
          });
          $rootEl.attr("aria-expanded", "true");
        } else {
          $rootEl.addClass("preloaded");
          $.get(
            this.options.url,
            {
              root_id: $rootEl.data(this.options.data_attribute),
            },
            function (resp) {
              var newRows = $(resp).find("table.projects tbody:first").children("tr");
              $rootEl.addClass("open");
              newRows.filter(".multieditable-container").each(function () {
                initInlineEditForContainer(this);
              });
              newRows.insertAfter(tr);
              $rootEl.attr("aria-expanded", "true");
            }
          );
        }
      }
    },
  });

  const serviseBarSlideAnimationSpeed = 250;

  function serviceBarAnimationDirection() {
    var direction = "right";
    var windowWidth = $(window).width();
    var serviceBarCollapse = EASY.getSassData("media-sidebar-collapse", 640, true);
    if (windowWidth < serviceBarCollapse) {
      direction = "down";
    }
    return direction;
  }

  function closeServiceBoxComponent() {
    $("#easy_servicebar_component").hide(
      "slide",
      { direction: serviceBarAnimationDirection() },
      serviseBarSlideAnimationSpeed
    );
    $("#easy_servicebar_component_body").html("");
    $("#easy_servicebar > ul > li").removeClass("active");
    ERUI.body.removeClass("servicebar-opened");
    $("#easy_servicebar").removeClass("withBackdrop");
    //ERUI.main.trigger($.Event('resize'));
    ERUI.document.off("keydown.easySlidingPanel");
  }

  function showServiceBoxComponent(trigger) {
    var $trigger, $parent;
    var $box = $("#easy_servicebar_component");
    $box.show("slide", { direction: serviceBarAnimationDirection() }, serviseBarSlideAnimationSpeed);
    $("#easy_servicebar > ul > li").removeClass("active");
    if (trigger) {
      $trigger = $(trigger);
      $parent = $trigger.parent();
      //$parent.on('click', closeServiceBoxComponent); //acording to issue 394625
      $box.attr({ class: $trigger.attr("id") });
      $parent.addClass("active");
      ERUI.body.addClass("servicebar-opened");
      $("#easy_servicebar").addClass("withBackdrop");
      //ERUI.main.trigger($.Event('resize'));
    }
    ERUI.document.on("keydown.easySlidingPanel", function (event) {
      if (event.keyCode === 27) {
        closeServiceBoxComponent();
      }
    });
  }

  $.fn.easySlidingPanel = function (options) {
    var _self = $(this);
    _self.find("#easy_servicebar_close_toggler").click(closeServiceBoxComponent);
    var specifiedElement = document.getElementById("easy_servicebar_component");
    var serviceBar = document.getElementById("easy_servicebar");
    serviceBar.addEventListener("click", function (event) {
      if (!$.contains($("#easy_servicebar_nav")[0], $(event.target)[0])) {
        var isClickInside = specifiedElement.contains(event.target);
        if (!isClickInside) {
          if ($("body > .movable-list-item").length === 0) {
            closeServiceBoxComponent();
          }
        }
      }
    });

    showServiceBoxComponent(options.trigger);
    return _self.find("#easy_servicebar_component_body");
  };
})(jQuery);
